import { Component } from "react";
import DataLoader from "./../../../../../DataLoader/DataLoader";
import SidePanelSection from "./../../../SidePanelSection/SidePanelSection";
import { Link } from "react-router-dom";
import { fetchLevels } from "./../../../../../../services/levels";
import { useTranslation } from "react-i18next";
import { buildExerciseLevelPath, isExerciseLevelActive } from "pages/Exercises/urlState";

export default class LevelSection extends Component {
  render() {
    return (
      <DataLoader fetchData={fetchLevels}>
        <LevelSectionInner {...this.props} />
      </DataLoader>
    );
  }
}

function LevelSectionInner(props) {
  const { t } = useTranslation();

  return (
    <SidePanelSection
      sectionTitle={t("Common.Level")}
      list={props.data}
      location={props.location}
      tagName={LevelListItem}
      isReducedList={true}
    />
  );
}

class LevelListItem extends Component {
  render() {
    const path = buildExerciseLevelPath(this.props.item.id);
    const isActive = isExerciseLevelActive(this.props.location, this.props.item.id);
    return (
      <li className={isActive ? "active" : ""}>
        <Link className="btn" to={path}>
          {this.props.item.name}
        </Link>
      </li>
    );
  }
}
